import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardHeader,
  Container,
  Row,
  Media,
  Modal,
  Button,
  UncontrolledTooltip
} from "reactstrap";
// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";

// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
// connect
import connect from 'redux-connect-decorator';
import { pagination } from '../../../../utils/ccl-utils';
import { getAllUsers, deleteUser, updateRole } from '../../../../actions/userActions';
import { AVATAR_DEFAULT } from '../../../../config/constants';
import { callbackify } from 'util';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { toast } from 'react-toastify';

const { SearchBar } = Search;

const formatRole = (cell, row) => {
  return <div>
    {cell.map((item, i) => (
      <div className={ `action-img ${item}`} key={`${row.student_email}-role-${i}`} ></div>
    ))}
  </div>;
}

const formatActivated = (cell, row) => {
  let component = null;
  if (cell) {
    component = <div><i className="ni ni-check-bold text-success"></i></div>;
  } else {
    component = <div><i className="ni ni-fat-remove text-warning"></i></div>
  }
  return component;
}

const formatUsername = (cell, row) => {
  return <Media className="align-items-center">
      <a className="avatar rounded-circle mr-3" onClick={e => e.preventDefault()}>
        <img alt="..." src={ row.avatar || AVATAR_DEFAULT } />
      </a>
      <Media>
        <span className="name mb-0 text-sm">
          { row.name }
        </span>
      </Media>
    </Media>;
}

@connect(
  state => ({
    users: state.user.users,
    loading: state.user.loading
  }),
  {
    getAllUsers
  }
)
class Users extends Component<any, any> {
  state = {
    selectedData: null,
    defaultModal: null,
    chkFree: false,
    chkSubscription: false,
    chkAdmin: false
  }

  componentDidMount() {
    this.props.getAllUsers();
  }

  constructor(props) {
    super(props);
  }

  toggleModal = state => {
    this.setState({
      [state]: !this.state[state]
    });
  };

  onDeleteUser = async (user) => {
    const result = await deleteUser(user._id);
    // Load user again
    if (result && result.status == 200) {
      this.props.getAllUsers();
      toast.success('Delete user success.');
    }
  }

  onUpdateUserRole = async () => {
    let authorities = [];
    if (this.state.chkAdmin) {
      authorities.push('ROLE_ADMIN');
    }
    if (this.state.chkFree) {
      authorities.push('ROLE_FREE_USER');
    }
    if (this.state.chkSubscription) {
      authorities.push('ROLE_SUBSCRIPTION_USER');
    }

    if (authorities.length == 0) {
      toast.error('User has no role. Can not update');
      return;
    }
    let user = { authorities, student_email: this.state.selectedData.student_email };
    const result = await updateRole(user);
    if (result && result.status == 200) {
      this.props.getAllUsers();
      toast.success('Update role for user success.');
      this.toggleModal("defaultModal");
    }
  }

  editRoleUser = (e, row) => {
    e.preventDefault();
    // reset
    this.setState({
      chkFree: false,
      chkSubscription: false,
      chkAdmin: false,
      selectedData: null
    });
    // logic
    this.setState({ selectedData: row });
    row.authorities.map((role) => {
      switch (role) {
        case 'ROLE_FREE_USER':
          this.setState({ chkFree: true});
          break;
        case 'ROLE_SUBSCRIPTION_USER':
          this.setState({ chkSubscription: true});
          break;
        case 'ROLE_ADMIN':
          this.setState({ chkAdmin: true});
          break;
        default:
          break;
        };
    });
    this.toggleModal("defaultModal");
  }

  confirmDelete = (e, row) => {
    e.preventDefault();
    confirmAlert({
      title: 'Confirm to delete',
      message: `Are you sure to delete user: ${row.student_email}`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.onDeleteUser(row)
        },
        {
          label: 'No',
          onClick: null
        }
      ]
    });
  }

  addActionButton = (cell, row) => {
    return (
        <div className="table-actions">
            <a
              className="table-action table-action-play"
              href="#"
              id="tooltip123539273"
              onClick={e => this.editRoleUser(e, row)}
            >
              <i className="fas fa-edit" />
            </a>
            <UncontrolledTooltip delay={0} target="tooltip123539273">
              Edit user
            </UncontrolledTooltip>
            <a
              className="table-action table-action-transcript"
              href="#"
              id="tooltip397466356"
              onClick={e => this.confirmDelete(e, row)}
            >
              <i className="fas fa-trash-alt" />
            </a>
            <UncontrolledTooltip delay={0} target="tooltip397466356">
              Delete user
            </UncontrolledTooltip>
        </div>
    )
  }

  handleCheckboxChange = (e, type) => {
    console.log(`${type} - ${e.target.checked}`);
    switch (type) {
      case 'ROLE_FREE_USER':
        this.setState({ chkFree: e.target.checked});
        break;
      case 'ROLE_SUBSCRIPTION_USER':
        this.setState({ chkSubscription: e.target.checked});
        break;
      case 'ROLE_ADMIN':
        this.setState({ chkAdmin: e.target.checked});
        break;
      default:
        break;
    }
  }

  render() {
    const { users } = this.props;
    return (
      <>
        <SimpleHeader name="Users" parentName="Management" />
        <Container className="mt--6" fluid>
        <Row>
            <div className="col">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">All users</h3>
                  <p className="text-sm mb-0">
                  </p>
                </CardHeader>
                { users && <ToolkitProvider
                  data={ users }
                  keyField="student_email"
                  columns={[
                    {
                      dataField: "name",
                      text: "Name",
                      formatter: formatUsername,
                      sort: true
                    },
                    {
                      dataField: "student_email",
                      text: "Email",
                      sort: true
                    },
                    {
                      dataField: "activated",
                      text: "Status",
                      formatter: formatActivated,
                      searchable: false,
                      sort: true
                    },
                    {
                      dataField: "authorities",
                      formatter: formatRole,
                      searchable: false,
                      text: "Role",
                      sort: true
                    },
                    {
                      dataField: "action",
                      text: "Action",
                      searchable: false,
                      sort: false,
                      formatter: this.addActionButton
                    }
                  ]}
                  search
                >
                  {props => (
                    <div className="py-4 table-responsive align-items-center table-flush table">
                      <div
                        id="datatable-basic_filter"
                        className="dataTables_filter px-4 pb-1"
                      >
                        <label>
                          Search:
                          <SearchBar
                            className="form-control-sm"
                            placeholder=""
                            {...props.searchProps}
                          />
                        </label>
                      </div>
                      <BootstrapTable
                        {...props.baseProps}
                        bootstrap4={true}
                        pagination={pagination}
                        bordered={false}
                      />
                    </div>
                  )}
                </ToolkitProvider>
                }
              </Card>
            </div>

            { this.state.selectedData && <Modal
              className="modal-dialog-centered"
              isOpen={this.state.defaultModal}
              toggle={() => this.toggleModal("defaultModal")}
            >
              <div className="modal-header">
                <h6 className="modal-title" id="modal-title-default">
                  <div>Update role of user</div>
                  <small>Email: { this.state.selectedData.student_email }</small>
                </h6>
                <button
                  aria-label="Close"
                  className="close"
                  data-dismiss="modal"
                  type="button"
                  onClick={() => this.toggleModal("defaultModal")}
                >
                  <span aria-hidden={true}>×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="custom-control custom-checkbox mb-3">
                  <input
                    className="custom-control-input"
                    id="role_free"
                    type="checkbox"
                    checked={ this.state.chkFree }
                    onChange={e => this.handleCheckboxChange(e, 'ROLE_FREE_USER')}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="role_free"
                  >
                    <div>Role free user</div>
                  </label>
                </div>
                <div className="custom-control custom-checkbox mb-3">
                  <input
                    className="custom-control-input"
                    id="role_subscription"
                    type="checkbox"
                    checked={ this.state.chkSubscription}
                    onChange={e => this.handleCheckboxChange(e, 'ROLE_SUBSCRIPTION_USER')}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="role_subscription"
                  >
                    <div>Role subscription user</div>
                  </label>
                </div>
                <div className="custom-control custom-checkbox mb-3">
                  <input
                    className="custom-control-input"
                    id="role_admin"
                    type="checkbox"
                    checked={ this.state.chkAdmin}
                    onChange={e => this.handleCheckboxChange(e, 'ROLE_ADMIN')}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="role_admin"
                  >
                    <div>Role ADMIN</div>
                  </label>
                </div>
              </div>
              <div className="modal-footer">
                <Button color="primary" type="button" onClick={this.onUpdateUserRole}>
                  Save changes
                </Button>
                <Button
                  className="ml-auto"
                  color="link"
                  data-dismiss="modal"
                  type="button"
                  onClick={() => this.toggleModal("defaultModal")}
                >
                  Close
                </Button>
              </div>
            </Modal>
            }
          </Row>
        </Container>
      </>
    );
  }
}

export default Users;
